/**
 * Legacy `CI` (current-page) storage key — port of
 * `LOCAL_STORAGE.CURRENT_PAGE = 'CI'`. The legacy `ValidateRouteGuard` writes
 * the active screen name here on every validated navigation (and `'raptorPortal'`
 * on a denial), flag-gated to sessionStorage vs localStorage by
 * `enableSessionStorage`. Legacy MFEs / the chatbot bridge read it for the
 * current app-context name.
 */
import { isEnvFlagTrue } from '@/config/env-flags';

const CURRENT_PAGE_KEY = 'CI';

export function setCurrentPage(page: string): void {
  const useSession = isEnvFlagTrue(import.meta.env.VITE_ENABLE_SESSION_STORAGE);
  try {
    if (useSession) {
      sessionStorage.setItem(CURRENT_PAGE_KEY, page);
      // Keep `CI` in exactly one store (legacy writes one location per flag).
      // Remove any stale copy left in the other store — e.g. entries written to
      // localStorage while the flag was momentarily false — so the two never
      // diverge (fixes localStorage still mirroring session values).
      localStorage.removeItem(CURRENT_PAGE_KEY);
    } else {
      localStorage.setItem(CURRENT_PAGE_KEY, page);
      sessionStorage.removeItem(CURRENT_PAGE_KEY);
    }
  } catch {
    /* storage unavailable (private mode / blocked) */
  }
}
